import { render } from "./sysDicListModule.vue?vue&type=template&id=29155b3c"
import script from "./sysDicListModule.vue?vue&type=script&lang=js"
export * from "./sysDicListModule.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__